import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import Layout from "../layouts/Layout";

export default function ProtectedRoute({ element }) {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <p>Cargando...</p>;
    }

    if (!isAuthenticated) {
        const reauthAfterLogout = sessionStorage.getItem("oidc_reauth_after_logout") === "true";
        const search = reauthAfterLogout && location.pathname === "/rulesView" ? "?reauth=1" : "";
        return <Navigate to={`/login${search}`} replace />;
    }

    return <Layout>{element}</Layout>;
}
